import {CalendarDays, Gauge, Radio} from 'lucide-react'
import {useApp} from '../../context/AppContext'
import {formatDate} from '../../utils/helpers'
import PageHeader from '../common/PageHeader'
import StatsGrid from './StatsGrid'
import ActivityFeed from './ActivityFeed'
import TaskDistribution from './TaskDistribution'
import UpcomingDeadlines from './UpcomingDeadlines'

export default function Dashboard() {
  const {state} = useApp()
  const {currentUser, loading} = state
  const hour = new Date().getHours()
  const greeting = hour < 12 ? 'Bom dia' : hour < 18 ? 'Boa tarde' : 'Boa noite'

  if (loading) {
    return (
      <div className='devops-page space-y-6 animate-pulse' aria-label='Carregando painel'>
        <div className='h-20 bg-white/70 rounded-2xl border border-slate-200' />
        <div className='grid grid-cols-2 lg:grid-cols-4 gap-4'>
          {[1, 2, 3, 4].map((item) => (
            <div key={item} className='h-32 bg-white/70 rounded-2xl border border-slate-200' />
          ))}
        </div>
        <div className='h-72 bg-white/70 rounded-2xl border border-slate-200' />
      </div>
    )
  }

  if (!currentUser) return null

  return (
    <div className='devops-page space-y-5 md:space-y-6'>
      <PageHeader
        eyebrow='Visão geral'
        icon={Gauge}
        title={`${greeting}, ${currentUser.name.split(' ')[0]}`}
        description='Acompanhe o ritmo das entregas, identifique gargalos e priorize o que precisa de atenção hoje.'
        meta={
          <>
            <span>
              <CalendarDays size={11} />
              {formatDate(new Date().toISOString())}
            </span>
            <span>
              <Radio size={11} className='text-emerald-500' />
              Dados atualizados
            </span>
          </>
        }
      />

      <StatsGrid />
      <TaskDistribution />

      <div className='grid grid-cols-1 xl:grid-cols-2 gap-4 md:gap-5'>
        <ActivityFeed />
        <UpcomingDeadlines />
      </div>
    </div>
  )
}
